module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9587.17c9e245.jpg";